<template>
  <DKitDeepBoxTagsAssignDialog
    v-if="bearer"
    v-model="model"
    :api-token="bearer"
    :box-id
    :env
    :manage-tags-url="linkManageTags"
    manage-tags-url-target="_blank"
    :nodes
    prevent-close-on-click-outside
    :type-id
    v-bind="$attrs"
    @update:tags="onSuccess"
  />
</template>

<script lang="ts" setup>
import { DKitDeepBoxTagsAssignDialog } from '@deepcloud/deep-ui-kit'
import { useAppsUrls } from '@/composables/apps-urls'
import { useKeycloak } from '@/composables/auth/keycloak.ts'
import { useNodeTags } from '@/composables/node/node-tags.ts'
import type { Node } from '@deepcloud/api-deep-box'
import type { DKitDeepBoxTagsAssignOnUpdateTags } from '@deepcloud/deep-ui-kit'

const props = defineProps({
  organizationId: {
    type: String,
    required: true,
  },
  typeId: {
    type: String,
    required: true,
  },
  boxId: {
    type: String,
    required: true,
  },
  nodes: {
    type: Array as PropType<Node[]>,
    default: () => [],
  },
})

const model = defineModel({ type: Boolean, default: false })

const emit = defineEmits<{
  success: [DKitDeepBoxTagsAssignOnUpdateTags]
}>()

const { bearer } = useKeycloak()
const env = import.meta.env.VITE_ENVIRONMENT

const { getDeepAdminOrgDeepBoxTypeTagsUrl } = useAppsUrls()

const linkManageTags = computed(() => {
  if (!props.organizationId) return undefined
  return getDeepAdminOrgDeepBoxTypeTagsUrl(props.organizationId, props.typeId)
})

const { updateNodeTags } = useNodeTags()

function onSuccess({ nodeId, tags }: DKitDeepBoxTagsAssignOnUpdateTags) {
  updateNodeTags({
    nodeId,
    tags,
  })
  emit('success', { nodeId, tags })
}
</script>
